import { Range } from 'slate';
var isRangeCollapsed = function isRangeCollapsed(range) {
  if (range) {
    return Range.isCollapsed(range);
  }
};
export { isRangeCollapsed };